import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { map, Observable, of } from 'rxjs';

import { BrowserService } from '@ideals/services/browser';
import { FeatureToggleService } from '@ideals/services/feature-toggle';
import { GeoService } from '@ideals/services/geo';

import { ACCESS_RESTRICTED_PATH, DESTINATION_URL_PARAM, INCOMPATIBLE_BROWSER_COOKIE, INCOMPATIBLE_BROWSER_PATH } from './types';

export function appGuard(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
  const browserService = inject(BrowserService);
  const cookieService = inject(CookieService);
  const geoService = inject(GeoService);
  const router = inject(Router);
  const featureToggleService = inject(FeatureToggleService);

  if (!featureToggleService.isEnabled('restricted-location-enabled')) {
    const isAllowed = browserService.isMobile
      || browserService.isBrowserVersionSupported({
        chrome: 109,
        'ms-edge-chromium': 109,
        'ms-edge': 109,
        safari: 16,
        firefox: 116,
        opera: 96,
      })
      || cookieService.check(INCOMPATIBLE_BROWSER_COOKIE);

    if (isAllowed) {
      return of(true);
    }

    return of(router.createUrlTree([INCOMPATIBLE_BROWSER_PATH], { queryParams: { [DESTINATION_URL_PARAM]: state.url } }));
  }

  return geoService.isBannedLocation.pipe(
    map((isBanned) => {
      if (isBanned) {
        return router.createUrlTree([ACCESS_RESTRICTED_PATH]);
      }

      const isAllowed = browserService.isMobile
        || browserService.isBrowserVersionSupported({
          chrome: 109,
          'ms-edge-chromium': 109,
          'ms-edge': 109,
          safari: 16,
          firefox: 116,
          opera: 96,
        })
        || cookieService.check(INCOMPATIBLE_BROWSER_COOKIE);

      if (isAllowed) {
        return true;
      }

      return router.createUrlTree([INCOMPATIBLE_BROWSER_PATH], { queryParams: { [DESTINATION_URL_PARAM]: state.url } });
    })
  );
}
